"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const effects_1 = require("redux-saga/effects");
const events_1 = require("./events");
const userProfile_1 = require("./userProfile");
const watchList_1 = require("./watchList");
const movie_1 = require("./movie");
const tickets_1 = require("./tickets");
const reviews_1 = require("./reviews");
function* rootSaga() {
    yield effects_1.all([
        userProfile_1.watchUserProfileAsync,
        userProfile_1.watchCreateUserAsync,
        events_1.watchFetchEventsAsync,
        watchList_1.watchFetchWatchListAsync,
        movie_1.movieWatchListAsync,
        watchList_1.addMovieToWatchLIstAsync,
        userProfile_1.watchRequestNewPasswordUserAsync,
        tickets_1.watchRequestTicketsAsync,
        reviews_1.watchFetchReviewsAsync
    ]);
}
exports.default = rootSaga;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-website-store/sagas.ts